import {
  authGet,
  authPost,
  awaitRequestJson,
  awaitRequestJsonOrNull,
  awaitRequestBlob,
} from '@/api/helpers'
import {
  AppIdParam,
  AppResponse,
  Version,
  SuccessResponse,
  VersionItem,
  SnowflakeDataSourcePayload,
  AppRank,
} from '@/types'

export function getAppByRank (appRank: AppRank) {
  return awaitRequestJson<AppResponse>(authGet('app', {}, appRank))
}

export function getAppById (params: AppIdParam, appRank: AppRank) {
  return awaitRequestJson<AppResponse>(authGet('app', params, appRank))
}

export function getVersionList (params: AppIdParam) {
  return awaitRequestJson<VersionItem[]>(authGet('versions', params))
}

export function postChangeCurrentVersion (newVersionId: Version['id'], params: AppIdParam) {
  return awaitRequestJson<SuccessResponse>(authPost('app/current-version', { newVersionId }, params))
}

export function getVersionStatus (appRank: AppRank) {
  return awaitRequestJson<Version['status']>(authGet('version/status', {}, appRank))
}

export function postVersionStatus (status: Version['status']) {
  return awaitRequestJson<SuccessResponse>(authPost('version/status', { status }))
}

export function getDataDownload (params: { fields: string[] }, appRank: AppRank) {
  // Todo: confirm response type
  return awaitRequestBlob(authGet('version/download', params, appRank))
}

export function postSnowflakeDataVersionSource (payload: SnowflakeDataSourcePayload) {
  // Todo: Response
  return awaitRequestJsonOrNull(authPost('version/source', payload))
}
